export const CareerOverviewData = [
  // {
  //   header: "Školitel řidičů VZV",
  //   text: "Každý den jiný, rozmanitá práce u našich zákazníků. Staňte se součástí našeho týmu RPK TECHNIK.",
  //   map: "Čechy",
  //   id: 0,
  // },
  {
    header: "Servisní technik v terénu",
    text: "Hledáme kolegu s technickým vzděláním nebo praxí, který tu bude pro naše zákazníky v oblasti středních Čech. Můžete být zkušený technik anebo absolvent, který cítí, že by to byla práce přesně pro něj. 😊    ",
    map: "Střední Čechy",
    id: 1,
  },
  // {
  //   header: "Servisní technik v terénu",
  //   text: "Hledáme kolegu s technickým vzděláním nebo praxí, který tu bude pro naše zákazníky v oblasti západních Čech. Můžete být zkušený technik anebo absolvent, který cítí, že by to byla práce přesně pro něj. 😊    ",
  //   map: "Západní Čechy",
  //   id: 2,
  // },
  // {
  //   header: "Servisní technik v terénu",
  //   text: "Hledáme kolegu s technickým vzděláním nebo praxí, který tu bude pro naše zákazníky v oblasti severních Čech. Můžete být zkušený technik anebo absolvent, který cítí, že by to byla práce přesně pro něj. 😊    ",
  //   map: "Severní Čechy",
  //   id: 3,
  // },
  // {
  //   header: "Servisní technik v terénu",
  //   text: "Hledáme kolegu s technickým vzděláním nebo praxí, který tu bude pro naše zákazníky v oblasti východních Čech. Můžete být zkušený technik anebo absolvent, který cítí, že by to byla práce přesně pro něj. 😊    ",
  //   map: "Východní Čechy",
  //   id: 4,
  // },
  // {
  //   header: "Servisní technik na dílně",
  //   text: "Hledáme kolegu s technickým vzděláním nebo praxí pro práci na dílenském provozu. Můžete být zkušený technik anebo absolvent, který cítí, že by to byla práce přesně pro něj. 😊    ",
  //   map: "Východní Čechy",
  //   id: 5,
  // },
];
